import { render, staticRenderFns } from "./ManageProjects.vue?vue&type=template&id=1a0e7142&scoped=true&"
import script from "./ManageProjects.vue?vue&type=script&lang=js&"
export * from "./ManageProjects.vue?vue&type=script&lang=js&"
import style0 from "./ManageProjects.vue?vue&type=style&index=0&id=1a0e7142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e7142",
  null
  
)

export default component.exports